import React from 'react';

const BillPrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '0px',
        // width: '400px', 
        //width: '300px',
        width: '400px',
        marginTop: '5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };

    // const NumberToWords = (num) => {
    //     const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    //     const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    //     const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    //     const convert = (num) => {
    //         if (num < 10) return units[num];
    //         if (num < 20) return teens[num - 11];
    //         if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
    //         if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100);
    //         if (num < 10000) return units[Math.floor(num / 1000)] + ' Thousand ' + convert(num % 1000);
            
    //         return 'Number is too large';
    //     };

    //     if (num === 0) return 'Zero';
    //     return convert(num);
    // };    

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const thousands = ['', 'Thousand', 'Million', 'Billion'];
    
        const convert = (num) => {
            if (num < 10) return units[num];
            if (num === 10) return 'Ten';
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100);
            
            let thousandIndex = 0;
            let result = '';
            while (num > 0) {
                if (num % 1000 !== 0) {
                    result = convert(num % 1000) + ' ' + thousands[thousandIndex] + ' ' + result;
                }
                num = Math.floor(num / 1000);
                thousandIndex++;
            }
            return result.trim();
        };
    
        if (num === 0) return 'Zero Rupees Only';
        
        let words = convert(num);
        return `${words}`;
    };
    
    
    


    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    // const NumberToWords = (num) => {
    //     const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    //     const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    //     const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    //     const scales = ['', 'Thousand', 'Lakh', 'Crore'];
    
    //     const convertBelowHundred = (num) => {
    //         if (num < 10) return units[num];
    //         if (num < 20) return teens[num - 11];
    //         if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 > 0 ? ' ' + units[num % 10] : '');
    //         return '';
    //     };
    
    //     const convertBelowThousand = (num) => {
    //         if (num < 100) return convertBelowHundred(num);
    //         return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 > 0 ? ' ' + convertBelowHundred(num % 100) : '');
    //     };
    
    //     const convert = (num) => {
    //         if (num === 0) return 'Zero';
    //         let word = '';
    //         let scaleIndex = 0;
    
    //         while (num > 0) {
    //             const remainder = num % 1000;
    //             if (remainder > 0) {
    //                 const scaleWord = scales[scaleIndex];
    //                 const remainderWord = convertBelowThousand(remainder);
    //                 word = remainderWord + (scaleWord ? ' ' + scaleWord : '') + ' ' + word;
    //             }
    //             num = Math.floor(num / 1000);
    //             scaleIndex++;
    //         }
    
    //         return word.trim();
    //     };
    
    //     if (isNaN(num) || num < 0) return 'Invalid Input';
    //     return convert(num);
    // };
    
    // const AmountInWords = ({ amount }) => {
    //     const formattedAmount = parseFloat(amount).toFixed(2);
    //     const [rupees, decimal] = formattedAmount.split('.');
    
    //     return (
    //         <div>
    //             <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
    //             {decimal !== '00' && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
    //         </div>
    //     );
    // };
        

    return (
        <div style={containerStyle}>
            {/* Render your label content using the fetched data */}
            {labelData && (
                <div>
                    <h3 style={{ textAlign: 'center', marginBottom: '2px', marginTop: '0px' }}>{labelData.SalePrint.CompanyName}</h3>
                    <h5 style={{ textAlign: 'center', marginBottom: '2px', marginTop: '0px' }}>{labelData.SalePrint.CompanyAddressLine}</h5>
                    <h5 style={{ textAlign: 'center', marginBottom: '2px', marginTop: '0px' }}>GST No : {labelData.SalePrint.CompanyGSTNumber}</h5>
                    <h5 style={{ textAlign: 'center', marginBottom: '2px', marginTop: '0px' }}>Phone No :{labelData.SalePrint.CompanyContactNumber1}</h5>

                </div>
            )}

            <hr style={{ border: '1px solid #000000', backgroundColor: '#000000', width: '100%' }} />

            <h4 style={{ textAlign: 'center', marginBottom: '2px', marginTop: '0px' }}>TAX INVOICE</h4>
            <hr style={{ border: '1px solid #000000', backgroundColor: '#000000', width: '100%' }} />
            <h5 style={{ marginBottom: '2px', marginTop: '0px', textAlign: 'left', marginLeft: '10px' }}>Bill No :{labelData.SalePrint.InvoiceNo}  <span style={{ marginLeft: '20px' }}>Bill Date :  {new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })} </span></h5>

            <hr style={{ border: '1px solid #000000', width: '100%', fontWeight: 'normal' }} />
            <table style={tableStyle}>

                <tr>
                    <td style={{ ...cellStyleN, width: '300px', textAlign: 'left', marginLeft: '3px' }} rowSpan={3}>
                        <h4>Customer : {labelData.SalePrint.CustomerName}  </h4>
                    </td>

                </tr>

            </table>

            {labelData && (
                <table style={{ ...tableStyle, marginTop: '-5px' }}>
                    <thead>
                        <tr>
                            <td style={{ ...cellStyleN, width: '650px' }}>
                                <h5 style={{ marginTop: '4px', marginBottom: '2px' }}>Item</h5>
                            </td>

                            <td style={{ ...cellStyleN, width: '80px' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>Qty</h5>
                            </td>

                            <td style={{ ...cellStyleN, width: '120px' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>Rate</h5>
                            </td>
                            <td style={{ ...cellStyleN, width: '120px' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>Disc</h5>
                            </td>
                            <td style={{ ...cellStyleN, width: '120px' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>Amount</h5>
                            </td>

                        </tr>
                    </thead>
                    <hr style={{ border: '1px solid #000000', width: '200%' }} />

                    <tbody>
                        {labelData &&
                            labelData.SalePrintItems.map((record, index) => (
                                <tr key={index} style={{ height: '40px' }}>

                                    <td style={{ ...cellStyleN, width: '300px', height: '40px', textAlign: 'left' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '13px', textAlign: 'left' }}>
                                            &nbsp;
                                            {record.ItemName}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyleN, width: '80px', height: '40px' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '13px' }}>
                                            {record.Quantity}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyleN, width: '120px', height: '40px' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '13px' }}>
                                            {record.Rate}
                                        </label>
                                    </td>
                                    <td style={{ ...cellStyleN, width: '120px', height: '40px' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '13px' }}>
                                            {record.DiscountAmount}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyleN, width: '180px', height: '40px' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '13px' }}>
                                            {record.TotalAmount}
                                        </label>
                                    </td>

                                </tr>
                            ))}
                    </tbody>
                </table>
            )}

            <hr style={{ border: '1px solid #000000', width: '100%', fontWeight: 'normal' }} />

            {labelData && (
                <table style={tableStyle}>

                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '10px', marginBottom: '3px', fontWeight: 'normal' }}>Total</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '10px', marginBottom: '3px' }}>{parseFloat(labelData.SalePrint.TaxableAmount).toFixed(2)}</h5>
                        </td>
                    </tr>





                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px', fontWeight: 'normal' }}>CGST</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px' }}>{parseFloat(labelData.SalePrint.CGSTAmount).toFixed(2)}</h5>
                        </td>
                    </tr>




                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px', fontWeight: 'normal' }}>SGST</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginBottom: '3px' }}>{parseFloat(labelData.SalePrint.SGSTAmount).toFixed(2)}</h5>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px', fontWeight: 'normal' }}>Discount</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px' }}>{parseFloat(labelData.SalePrint.DiscountAmount).toFixed(2)}</h5>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px', fontWeight: 'normal' }}>Round Off</h5>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h5 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px' }}>{parseFloat(labelData.SalePrint.RoundOff).toFixed(2)}</h5>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ ...cellStyleN, width: '300px', textAlign: 'right' }}>
                            <h4 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px', fontWeight: 'normal' }}>Grand Total</h4>
                        </td>
                        <td style={{ ...cellStyleN, width: '100px', textAlign: 'right' }}>
                            <h3 style={{ marginRight: '10px', fontFamily: 'Arial', marginTop: '3px', marginBottom: '3px' }}>{parseFloat(labelData.SalePrint.TotalAmount).toFixed(2)}</h3>
                        </td>

                    </tr>
                </table>
            )}

            <hr style={{ border: '1px solid #000000', width: '100%' }} />

            {labelData && (

                <h5 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}><AmountInWords amount={labelData.SalePrint.TotalAmount} /></h5>
            )}
            {labelData && (
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <td style={{ ...cellStyle, width: '80px' }}>
                                <h5 style={{ marginTop: '4px', marginBottom: '2px' }}>%</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '80px' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>Amount</h5>
                            </td>

                            <td style={{ ...cellStyle, width: '120px' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>CGST</h5>
                            </td>
                            <td style={{ ...cellStyle, width: '120px' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>SGST</h5>
                            </td>
                            <td style={{ ...cellStyle, width: '120px' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>Total</h5>
                            </td>

                        </tr>
                    </thead>
                    <tbody>
                        {labelData &&
                            labelData.PrintGSTwiseSP.map((record, index) => (
                                <tr key={index} style={{ height: '40px' }}>

                                    <td style={{ ...cellStyle, width: '30px', height: '40px', textAlign: 'left' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '14px', textAlign: 'left' }}>
                                            &nbsp;
                                            {record.GSTRate}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyle, width: '180px', height: '40px' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '14px' }}>
                                            {record.TaxableAmount}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyle, width: '180px', height: '40px' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '14px' }}>
                                            {record.CGSTAmount}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyle, width: '120px', height: '40px' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '14px' }}>
                                            {record.SGSTAmount}
                                        </label>
                                    </td>

                                    <td style={{ ...cellStyle, width: '180px', height: '40px' }}>
                                        <label style={{ marginTop: '5px', fontFamily: 'Arial', fontSize: '14px' }}>
                                            {record.TotalAmount}
                                        </label>
                                    </td>

                                </tr>
                            ))}
                    </tbody>
                </table>
            )}

            <div style={{ textAlign: 'left', marginTop: '-10px' }}>
                <p style={{ marginLeft: '5px', fontWeight: 'bold' }}>Terms & Conditions</p>
                <p style={{ marginLeft: '5px' }}> <b>.</b> Exchange of goods is possible if returned in orginal packaging within 10 days from the date of invoice.</p>
                <p style={{ marginLeft: '5px', marginTop: '-5px' }}> <b>.</b> No cash refund</p>
                <p style={{ marginLeft: '5px', marginTop: '-5px' }}> <b>.</b> Dry wash only for all silk and party wear dress or materials.</p>
            </div>
            <div style={{ textAlign: 'center', marginTop: '-10px' }}>
                <h5 style={{ marginBottom: '2px' }}>THANK YOU. VISIT AGAIN</h5>
            </div>
            {/* {labelData && (
                )} */}
            {/* <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style> */}

        </div>
    );
};

export default BillPrint;
